import { createFileRoute, redirect } from '@tanstack/react-router';

/** Your own page is now the Profile section of Settings. */
export const Route = createFileRoute('/_app/me')({
  beforeLoad: () => {
    throw redirect({ to: '/settings', search: { section: 'profile' } });
  },
});
